import React from "react";
import "./Pokerwatch_new.css";
function CurrentFilter(props) {
  return (
    <div>
      {props.filterStatusObj &&
        props.filterStatusObj.map((item, index) => {
          return (
            item.showView && (
              <div key={index} className="current-filter-div">
                <p>
                  {item.key} - {item.value}{" "}
                  {item.visible && (
                    <i
                      className="fa fa-s fa-times"
                      style={{
                        float: "right",
                        marginLeft: "10px",
                      }}
                      onClick={() =>
                        item.action({ target: { value: item.passedValue } })
                      }
                    ></i>
                  )}
                </p>
              </div>
            )
          );
        })}
    </div>
  );
}

export default CurrentFilter;



/** WEBPACK FOOTER **
 ** ./src/components/PokerWatchNew/CurrentFilter.js
 **/